/*
 * @Descripttion: xixi
 * @Date: 2020-09-17 14:16:51
 */
/*
    公共组件
*/

// common-components
const HeaderComponent = () => import("./header.vue");
const SideMenu = () => import("./sidemenu.vue");
// el-components
const CheckboxComponent = () => import("./el-components/checkbox-component.vue");
const DateComponent = () => import("./el-components/date-component.vue");
const DateRangeComponent = () => import("./el-components/daterange-component.vue");
const InputComponent = () => import("./el-components/input-component.vue");
const MultipleSelectComponent = () => import("./el-components/multiple-select-component.vue");
const NumberComponent = () => import("./el-components/number-component.vue");
const RadioComponent = () => import("./el-components/radio-component.vue");
const SingleSelectComponent = () => import("./el-components/single-select-component.vue");
const SwitchComponent = () => import("./el-components/switch-component.vue");
const UploadComponent = () => import("./el-components/upload-component.vue");
// mine-components
const ModifyEmail = () => import("./mine/modifyEmail.vue");
const ModifySim = () => import("./mine/modifySim.vue");
const ModifyName = () => import("./mine/modifyName.vue");
const ModifyAvatar = () => import("./mine/modifyAvatar.vue");
const ModifyPassword = () => import("./mine/modifyPassword.vue");
const Power = () => import("./mine/power.vue");
const Identify = () => import("./mine/identify.vue");

const commonComponent = {
    install: (Vue) => {
        Vue.component("headerComponent", HeaderComponent);
        Vue.component("sideMenu", SideMenu);
        Vue.component("checkboxComponent", CheckboxComponent);
        Vue.component("dateComponent", DateComponent);
        Vue.component("daterangeComponent", DateRangeComponent);
        Vue.component("inputComponent", InputComponent);
        Vue.component("multipleSelectComponent", MultipleSelectComponent);
        Vue.component("numberComponent", NumberComponent);
        Vue.component("radioComponent", RadioComponent);
        Vue.component("singleSelectComponent", SingleSelectComponent);
        Vue.component("switchComponent", SwitchComponent);
        Vue.component("uploadComponent", UploadComponent);
        Vue.component("modifyEmail", ModifyEmail);
        Vue.component("modifyName", ModifyName);
        Vue.component("modifyAvatar", ModifyAvatar);
        Vue.component("modifyPassword", ModifyPassword);
        Vue.component("power", Power);
        Vue.component("identify", Identify);
        Vue.component("modifySim", ModifySim);
    },
}

export default commonComponent;



// WEBPACK FOOTER //
// ./src/components/common-components.js